import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white rounded-2xl border border-divider p-3 sm:p-4 shadow-sm flex flex-wrap items-center justify-between gap-2" }
const _hoisted_2 = { class: "flex items-center gap-1.5" }


import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'DayReportControlsComponent',
  emits: ["backToCalendar", "nextDay", "prevDay"],
  setup(__props, { emit: __emit }) {

const emits = __emit;

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "px-3.5 py-2 rounded-xl bg-secondary hover:bg-hover text-brown text-xs font-bold border border-divider transition-colors flex items-center gap-1.5",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('backToCalendar')))
    }, _toDisplayString(_unref(t)("calculators.personal-date.controls.back-to-calendar")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "px-3 py-2 rounded-xl bg-secondary hover:bg-hover text-brown text-xs font-semibold border border-divider transition-colors",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('prevDay')))
      }, _toDisplayString(_unref(t)("calculators.personal-date.controls.prev-day")), 1),
      _createElementVNode("button", {
        class: "px-3 py-2 rounded-xl bg-secondary hover:bg-hover text-brown text-xs font-semibold border border-divider transition-colors",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('nextDay')))
      }, _toDisplayString(_unref(t)("calculators.personal-date.controls.next-day")), 1)
    ])
  ]))
}
}

})